import { render, staticRenderFns } from "./UserToolbarMenu.vue?vue&type=template&id=39fc8a60&scoped=true"
import script from "./UserToolbarMenu.vue?vue&type=script&lang=js"
export * from "./UserToolbarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fc8a60",
  null
  
)

export default component.exports